export default "__VITE_ASSET__8ac07aaf__"